// Shared Studio-wide constants. Keep these in one place rather than re-declaring
// them next to each consumer — magic numbers scattered across reducer / list /
// chat panel become a coordination problem the first time one needs to change.

// Cap on the rolling list of build/status events kept in memory for an active
// stream. Older events are dropped silently — they're a live-status feed, not an
// audit log.
export const MAX_STATUS_EVENTS = 50;

// Cap on the number of streaming agent events (tool calls / thoughts / file
// writes) held for the current turn. Reuses the same drop-on-overflow strategy
// as MAX_STATUS_EVENTS.
export const MAX_EVENTS = 200;

// EventList collapses to a summary when the agent emits more than this many
// events in a single turn — keeps the chat panel scrollable.
export const EVENT_COLLAPSE_THRESHOLD = 5;

// Two messages further apart than this in wall-clock time get a date separator
// rendered between them in the chat history.
export const DATE_SEPARATOR_GAP_MS = 60 * 60 * 1000;
